import { render } from "./QaManagementHub.vue?vue&type=template&id=3ee7668a&scoped=true"
import script from "./QaManagementHub.vue?vue&type=script&lang=js"
export * from "./QaManagementHub.vue?vue&type=script&lang=js"

import "./QaManagementHub.vue?vue&type=style&index=0&id=3ee7668a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee7668a"]])

export default __exports__